import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { APP_API_URL } from "../../utils";
import OrderLayout from "../../layout/order-layout";
import InvoiceComponent from "../../components/invoice";
import Loader from "../../components/loader";
import FactureComponent from "../../components/facture";

export default function UpdateInvoice() {
  const { reference } = useParams();
  const user = useSelector((state) => state.auth.user);
  const [invoiceData, setInvoiceData] = useState({});
  const [isLoading, setLoading] = useState(false);

  // Fonction pour récupérer les données de la commande
  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${APP_API_URL}/commandes/reference/${reference}`, {
        params: {
          user_id: user.id, // Passer l'ID de l'utilisateur comme paramètre
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setInvoiceData(response.data.data);
    } catch (error) {
      console.error('Erreur lors de la récupération des commandes :', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${APP_API_URL}/validate/commandes`, { commande_id: invoiceData.id, validated_by_id: user.id }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.status === 200) {
        fetchData();

        setTimeout(() => {
          // Afficher une alerte de succès avec SweetAlert
          Swal.fire({
            icon: 'success',
            title: 'Commande validée !',
            text: response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
        }, 1000);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Des erreurs ont été détectées dans le formulaire.',
          footer: 'Vérifiez les champs et réessayez.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: error.error || 'Rupture de stock sur l\'un des produits',
        });
      }
    } finally {
      setLoading(false);
    }
  };
  
  const handlePrint = () => {
    const previousTitle = document.title;
    document.title = `ASEBât - ${invoiceData.designation} - Vente de matériaux de construction`;

    window.print();

    document.title = previousTitle;
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <OrderLayout document>
      <div className="mx-auto w-full max-w-6xl bg-white p-4 sm:p-6 lg:p-8">
        <div className="printable w-full">

          <FactureComponent invoiceData={invoiceData} isCopy={false} />
          <FactureComponent invoiceData={invoiceData} />
          <InvoiceComponent invoiceData={invoiceData} />
          <InvoiceComponent invoiceData={invoiceData} />

          <div className="modal-footer py-4 space-x-4 no-print">
            {invoiceData.statut_commande === "en cours" ? (
              <form onSubmit={handleSubmit}>
                {isLoading ? (
                  <button
                    type="button"
                    disabled
                    className="inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-300"
                  >
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-4 h-4 me-2 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                    Validation en cours...
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-300"
                  >
                    Valider
                  </button>
                )}
              </form>
            ) : (
              <>
                <button
                  type="button"
                  onClick={handlePrint} // Appel de la fonction handlePrint pour imprimer
                  className="inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-300"
                >
                  Imprimer
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </OrderLayout>
  );
}
